'use client';
import type { ChangeEvent } from 'react';
import { useRouter } from 'next/navigation';

import { blogCategoryUrl } from 'src/services/route-utils';

type Props = {
    categories: any[];
    selected: any;
};

export default function BlogCategories({ categories, selected }: Props) {
    const router = useRouter();

    const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
        const item = e.target.value;
        router.push(blogCategoryUrl(item ? { slug: item } : null));
    };

    return (
        <select onChange={handleChange} value={selected || ''}>
            <option value="">Toate categoriile</option>
            {categories.map((c) => (
                <option key={c.slug} value={c.slug}>
                    {c.name}
                </option>
            ))}
        </select>
    );
}
